import React from 'react';
import ButtonSeplag from '../../../../components/buttonSeplag/ButtonSeplag';
import Pages from '../../../../config/Pages';
import analiseNegocialService from '../../../../service/AnaliseNegocialService';
import { download } from '../../../../core/utils/Exporter';
import LinkTo from '../../../../core/components/LinkTo';
import { useHistory } from 'react-router-dom';

export default function AfterActionsButtons({ dados }) {
    const history = useHistory();
    return (
        <>
            <ButtonSeplag
                tipo="warning"
                type="button"
                tooltip="Analisar"
                tooltipOptions={{ position: 'top' }}
                icon="pi pi-file-edit"
                style={{ marginLeft: '5px' }}
                onClick={() =>
                    history.push(Pages.sei.analiseNegocial.url.edit.replace(':id', dados.id))
                }
            />
            <LinkTo to={Pages.sei.statusProposta.url.list.replace(':id', dados?.proposta?.id)}>
                <ButtonSeplag
                    tipo="help"
                    type="button"
                    tooltip="Status da Proposta"
                    tooltipOptions={{ position: 'top' }}
                    icon="pi pi-arrow-right-arrow-left"
                    style={{ marginLeft: '.5em' }}
                />
            </LinkTo>
            <ButtonSeplag
                tipo="secondary"
                type="button"
                tooltip="Relatório da Análise Negocial"
                tooltipOptions={{ position: 'top' }}
                icon="pi pi-file-pdf"
                onClick={() =>
                    analiseNegocialService
                        .getRelatorio(dados.id)
                        .then((response) => download(response, 'Analise Negocial', 'pdf'))
                }
                style={{ marginLeft: '.5em', marginTop: '-.1em' }}
                theme="Raised"
            />
        </>
    );
}
